// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const confirmationStep = "ConfirmationStep__confirmationStep__bOj4a";
export const buttonWrapper = "ConfirmationStep__buttonWrapper__qpO5V";
export const confirmationTable = "ConfirmationStep__confirmationTable__xmzg6";
export const confirmationSection = "ConfirmationStep__confirmationSection__khGmB";
export const confirmationSectionButtonWrapper = "ConfirmationStep__confirmationSectionButtonWrapper__20qoK";
export const confirmationLabel = "ConfirmationStep__confirmationLabel__Ke1r8";
export const confirmationValue = "ConfirmationStep__confirmationValue__ymuUO";
export const errorBorder = "ConfirmationStep__errorBorder__EoxJg font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const errorFieldNameList = "ConfirmationStep__errorFieldNameList__UQjLP";
export const errorFieldNameItem = "ConfirmationStep__errorFieldNameItem__FhAMj";